import { Helmet } from "react-helmet-async";
import styled from "styled-components/macro";

import {
  Grid,
  Divider as MuiDivider, Typography,
} from "@mui/material";
import { green, red } from "@mui/material/colors";
import { spacing } from "@mui/system";

import { useContext } from "react";
import { TogglePlatformContext } from "../../../contexts/ToggleContext";
import DoughnutChart from "./DoughnutChart";
import LineChart from "./LineChart";
import Stats from "./Stats";

const Divider = styled(MuiDivider)(spacing);

export default function Default() {
  const {webPlatform} = useContext(TogglePlatformContext);
  const isWeb = webPlatform ?? true;

  return (
    <>
      <Helmet title="Tazkia Admin Dashboard"/>
      {/* web */}
      {isWeb ? (
        <>
          <Typography variant="h5">Total Members</Typography>
          <Divider my={6}/>
          <Grid container spacing={{xs: 2, md: 3}} columns={{xs: 4, sm: 8, md: 12}}>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Male Members"
                amount={0}
                chip="Total"
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Female Members"
                amount={0}
                chip="Total"
                percentagetext=""
                percentagecolor={red[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Total Members"
                amount={0}
                chip="Total "
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Members by Country"
                amount={0}
                chip="Total "
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Members by District"
                amount={0}
                chip="Total "
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
          </Grid>
          <Typography variant="h5">Donations</Typography>
          <Divider my={6}/>
          <Grid container spacing={{xs: 2, md: 3}} columns={{xs: 4, sm: 8, md: 12}}>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Member donation"
                amount={0}
                chip="Total"
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Guest user donation"
                amount={0}
                chip="Total"
                percentagetext=""
                percentagecolor={red[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Total donation amount"
                amount={0}
                chip="Total "
                percentagetext=""
                percentagecolor={green[500]}
                illustration="/static/img/illustrations/waiting.png"
              />
            </Grid>
          </Grid>
          <Typography variant="h5">Miscellaneous</Typography>
          <Divider my={6}/>
          <Grid container spacing={{xs: 2, md: 3}} columns={{xs: 4, sm: 8, md: 12}}>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Amaliat PDF Files Count"
                amount={0}
                chip="Total"
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Total Masyala Count"
                amount={0}
                chip="Total"
                percentagetext=""
                percentagecolor={red[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Total Books Count"
                amount={0}
                chip="Total "
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Total Article Count"
                amount={0}
                chip="Total "
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Total Khanka Count"
                amount={0}
                chip="Total "
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Yearly Event Count"
                amount={0}
                chip="Total "
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Event Participants"
                amount={0}
                chip="Total "
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Typography variant="h5">Total User</Typography>
          <Divider my={6}/>
          <Grid container spacing={{xs: 2, md: 3}} columns={{xs: 4, sm: 8, md: 12}}>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Male Members"
                  amount={0}
                chip="Total"
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Female Members"
                  amount={0}
                chip="Total"
                percentagetext=""
                percentagecolor={red[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Members by country"
                  amount={0}
                chip="Total "
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Members by Amount"
                  amount={0}
                chip="Total "
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
          </Grid>
          <Typography variant="h5">Miscellaneous</Typography>
          <Divider my={6}/>
          <Grid container spacing={{xs: 2, md: 3}} columns={{xs: 4, sm: 8, md: 12}}>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Total Books Count"
                  amount={0}
                chip="Total"
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Total Masyala Count"
                  amount={0}
                chip="Total"
                percentagetext=""
                percentagecolor={red[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Dua"
                  amount={0}
                chip="Total "
                percentagetext=""
                percentagecolor={green[500]}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Stats
                title="Total Donation"
                  amount={0}
                chip="Total "
                percentagetext=""
                  percentagecolor={green[500]}
                  illustration="/static/img/illustrations/waiting.png"
              />
            </Grid>
            </Grid>
        </>
      )}

      <Grid container spacing={6}>
        <Grid item xs={12} lg={8}>
          <LineChart />
        </Grid>
        <Grid item xs={12} lg={4}>
          <DoughnutChart />
        </Grid>
      </Grid>
    </>
  );
}
